import * as React from 'react';

export enum SvgIcons
{
    close = 'close',
    search = 'search',
    favorite = 'favorite',
    recent = 'recent',
    font = 'font',
    allItems = 'allItems',
    postPlus = 'postPlus',
    moreHorizontal = 'moreHorizontal',
    fullscreen = 'fullscreen',
    fullscreenExit = 'fullscreenExit',
    photo = 'photo',
    wallpaper = 'wallpaper',
    publish = 'publish',
    arrowRight = 'arrowRight',
    check = 'check',

    // cursors
    cursor_default = 'cursor_default',
    cursor_none = 'cursor_none',
    cursor_context_menu = 'cursor_context_menu',
    cursor_help = 'cursor_help',
    cursor_pointer = 'cursor_pointer',
    cursor_progress = 'cursor_progress',
    cursor_wait = 'cursor_wait',
    cursor_cell = 'cursor_cell',
    cursor_crosshair = 'cursor_crosshair',
    cursor_text = 'cursor_text',
    cursor_vertical_text = 'cursor_vertical_text',
    cursor_alias = 'cursor_alias',
    cursor_copy = 'cursor_copy',
    cursor_move = 'cursor_move',
    cursor_all_scroll = 'cursor_all_scroll',
    cursor_no_drop = 'cursor_no_drop',
    cursor_not_allowed = 'cursor_not_allowed',
    cursor_zoom_in = 'cursor_zoom_in',
    cursor_zoom_out = 'cursor_zoom_out',
    cursor_grab = 'cursor_grab',
    cursor_grabbing = 'cursor_grabbing',
    cursor_custom = 'cursor_custom',
}

export const Icons:Map<SvgIcons, (props:any) => JSX.Element> = new Map([
    [
        SvgIcons.font,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M17,8H20V20H21V21H17V20H18V17H14L12.5,20H14V21H10V20H11L17,8M18,9L14.5,16H18V9M5,3H10C11.11,3 12,3.89 12,5V16H9V11H6V16H3V5C3,3.89 3.89,3 5,3M6,5V9H9V5H6Z"
                />
            </svg>
        )
    ],
    [
        SvgIcons.close,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                />
            </svg>
        )
    ],
    [
        SvgIcons.search,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                />
            </svg>
        )
    ],
    [
        SvgIcons.favorite,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </svg>
        )
    ],
    [
        SvgIcons.recent,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
            </svg>
        )
    ],
    [
        SvgIcons.allItems,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z" />
            </svg>
        )
    ],
    [
        SvgIcons.postPlus,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z" />
                <path
                    d="M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z" />
            </svg>
        )
    ],
    [
        SvgIcons.moreHorizontal,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
        )
    ],
    [
        SvgIcons.fullscreen,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
            </svg>
        )
    ],
    [
        SvgIcons.fullscreenExit,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
            </svg>
        )
    ],
    [
        SvgIcons.photo,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
            </svg>
        )
    ],
    [
        SvgIcons.wallpaper,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    d="M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z" />
                <path d="M0 0h24v24H0z" fill="none" />
            </svg>
        )
    ],
    [
        SvgIcons.publish,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z" />
            </svg>
        )
    ],
    [
        SvgIcons.arrowRight,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d='M10 17l5-5-5-5v10z' />
                <path fill='none' d='M0 24V0h24v24H0z' />
            </svg>
        )
    ],
    [
        SvgIcons.check,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path fill='none' d='M0 0h24v24H0z' />
                <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' />
            </svg>
        )
    ],
    // cursors
    [
        SvgIcons.cursor_default,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M15.923 16.03c.176.42.007 2.015-.923 2.384-.93.37-2.118 0-2.118 0l-2.156-4.312L7 17.828V1l11.414 11.414h-4.253c.21.4 1.54 3.08 1.762 3.616Z"
                        fill="#fff" />
                    <path
                        d="M8 3.414v12l3-3 2.5 5s.676.216 1 0c.324-.216.646-.65.5-1-.688-1.65-2.5-5-2.5-5H16l-8-8Z"
                        fillRule="evenodd" clipRule="evenodd"
                        fill="#000" />
                </g>
                <defs>
                    <filter id="filter0_1" x="0" y="0" width="24" height="24"
                            filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha" />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation=".9" />
                        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
                        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_none,
        props => null
    ],
    [
        SvgIcons.cursor_context_menu,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)" fillRule="evenodd" clipRule="evenodd">
                    <path d="M12 18.47V19h9V9h-9V18.47Z" fill="#fff" />
                    <path d="m7.225 14.29 2.255 5.341 3.604-1.535-2.1-5.07h4.607L4 1.406v16.016l3.225-3.132Z"
                          fill="#fff" />
                    <path d="M20 18h-7v-8h7v8Zm-1-5h-5v-1h5v1Zm-5 2h5v-1h-5v1Zm5 2h-5v-1h5v1Z" fill="#000" />
                    <path d="m7.537 12.553 2.37 5.636 1.844-.773-2.28-5.419h3.694L5 3.814v11.188l2.537-2.45Z"
                          fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_help,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M8.675 5.1l.047-.036a5.744 5.744 0 0 1 3.193-1.062c1.411-.093 2.793.437 3.71 1.384.948.8 1.452 2.008 1.355 3.16a4.025 4.025 0 0 1-.826 2.447c-.393.481-.85.907-1.304 1.224l-.544.44a.86.86 0 0 0-.262.333c-.06.145-.053.38-.044.574v1.046h-4l-.018-.933a8.445 8.445 0 0 1 .13-2.125c.097-.383.297-.703.59-1.007.198-.206.346-.329.818-.7l.597-.47c.16-.118.303-.254.38-.344a.983.983 0 0 0 .173-.456c.003-.125-.038-.248-.16-.402-.12-.172-.325-.264-.595-.235a.985.985 0 0 0-.642.28 1.19 1.19 0 0 0-.293.75l-.027.972H7.058l-.075-.919A4.55 4.55 0 0 1 8.675 5.1z"
                        fill="#fff" />
                    <path
                        d="M9.3 5.88A4.79 4.79 0 0 1 11.98 5a3.84 3.84 0 0 1 3 1.15 2.84 2.84 0 0 1 1 2.4 3 3 0 0 1-.6 1.81 5.842 5.842 0 0 1-1.16 1.08l-.53.43a1.87 1.87 0 0 0-.6.82c-.064.19-.104.609-.09.92h-2a7.4 7.4 0 0 1 .08-1.81c.11-.43.5-.73 1.06-1.17l.57-.45c.227-.167.432-.362.61-.58a2 2 0 0 0 .35-1 1.53 1.53 0 0 0-.34-1 1.57 1.57 0 0 0-1.47-.66 2 2 0 0 0-1.34.62 2.19 2.19 0 0 0-.54 1.38h-2a3.55 3.55 0 0 1 1.25-3"
                        fill="#000" />
                    <path d="M14 14v4h-4v-4h4z" fill="#fff" />
                    <path d="M13 15h-2v2h2v-2z" fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_pointer,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M8.27 16.28c-.28-.36-.63-1.09-1.24-2-.35-.5-1.21-1.45-1.47-1.94a1.26 1.26 0 0 1-.15-1 1.32 1.32 0 0 1 1.43-1c.51.103.98.353 1.35.72.258.243.496.507.71.79.16.2.2.28.38.51.18.23.3.46.21.12-.07-.5-.19-1.34-.36-2.09-.13-.57-.16-.66-.28-1.09-.12-.43-.19-.79-.32-1.28a14.162 14.162 0 0 1-.28-1.46 2.82 2.82 0 0 1 .26-1.85 1.19 1.19 0 0 1 1.3-.22c.44.325.77.78.94 1.3.262.64.437 1.313.52 2 .16 1 .47 2.46.48 2.76 0-.37-.07-1.15 0-1.5a1.07 1.07 0 0 1 .67-.8 2 2 0 0 1 .92-.06c.31.065.585.243.77.5.232.583.36 1.203.38 1.83a6.73 6.73 0 0 1 .28-1.62 1.24 1.24 0 0 1 .69-.48c.33-.06.67-.06 1 0 .271.09.508.262.68.49.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 1 1 1.9.64v2.26a11.74 11.74 0 0 1-.24 1.74 5.908 5.908 0 0 1-.72 1.43 7.214 7.214 0 0 0-1.19 1.81 4.004 4.004 0 0 0-.1 1c-.001.31.04.62.12.92a5.853 5.853 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .18-1-.23-1.36-.41-.36-.83-.78-1.14-1.06l-.84-.96z"
                        fill="#fff" />
                    <path
                        d="M8.27 16.28c-.28-.36-.63-1.09-1.24-2-.35-.5-1.21-1.45-1.47-1.94a1.26 1.26 0 0 1-.15-1 1.32 1.32 0 0 1 1.43-1c.51.103.98.353 1.35.72.258.243.496.507.71.79.16.2.2.28.38.51.18.23.3.46.21.12-.07-.5-.19-1.34-.36-2.09-.13-.57-.16-.66-.28-1.09-.12-.43-.19-.79-.32-1.28a14.162 14.162 0 0 1-.28-1.46 2.82 2.82 0 0 1 .26-1.85 1.19 1.19 0 0 1 1.3-.22c.44.325.77.78.94 1.3.262.64.437 1.313.52 2 .16 1 .47 2.46.48 2.76 0-.37-.07-1.15 0-1.5a1.07 1.07 0 0 1 .67-.8 2 2 0 0 1 .92-.06c.31.065.585.243.77.5.232.583.36 1.203.38 1.83a6.73 6.73 0 0 1 .28-1.62 1.24 1.24 0 0 1 .69-.48c.33-.06.67-.06 1 0 .271.09.508.262.68.49.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 1 1 1.9.64v2.26a11.74 11.74 0 0 1-.24 1.74 5.908 5.908 0 0 1-.72 1.43 7.21 7.21 0 0 0-1.19 1.81 4.004 4.004 0 0 0-.1 1c-.001.31.04.62.12.92a5.853 5.853 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .18-1-.23-1.36-.41-.36-.83-.78-1.14-1.06l-.84-.96z"
                        fill="#fff" stroke="#000"
                        clipRule="evenodd"
                        strokeWidth=".75" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M16.75 16.826v-3.452a.375.375 0 0 0-.75 0v3.452a.375.375 0 0 0 .75 0zm-1.98-.001l-.02-3.454a.374.374 0 0 0-.75.004l.02 3.454a.374.374 0 0 0 .75-.004zM12 13.379l.02 3.446a.376.376 0 1 0 .75-.004l-.02-3.446a.376.376 0 1 0-.75.004z"
                        fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_progress,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)" fillRule="evenodd" clipRule="evenodd">
                    <path d="M21 11a9 9 0 0 1-9 9v-9H3a9 9 0 0 1 9-9v9h9Z" fill="#4CC5FA" />
                    <path d="M3 11h9V2a9 9 0 0 1 9 9h-9v9a9 9 0 0 1-9-9Z" fill="#3482E5" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_wait,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)" fillRule="evenodd" clipRule="evenodd">
                    <path d="M21 11a9 9 0 0 1-9 9v-9H3a9 9 0 0 1 9-9v9h9Z" fill="#4CC5FA" />
                    <path d="M3 11h9V2a9 9 0 0 1 9 9h-9v9a9 9 0 0 1-9-9Z" fill="#3482E5" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_cell,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path d="M14 9h5v4h-5v5h-4v-5H5V9h5V4h4v5Z" fill="#000" />
                    <path d="M13 10h5v2h-5v5h-2v-5H6v-2h5V5h2v5Z" fill="#fff" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_crosshair,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M12.99 10V4h-2.98v6H4v3h6.01v6h2.98v-6H19v-3h-6.01Z" fill="#fff" />
                <path d="M12 11V5h-1v6H5v1h6v6h1v-6h6v-1h-6Z" fill="#232020" />
            </svg>
        )
    ],
    [
        SvgIcons.cursor_text,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M11.01 19.547c.161-.148.326-.308.482-.48.136.157.285.309.456.451l.01.01.012.008c.422.313.863.549 1.332.716l.031.011.032.007c.54.117 1.074.23 1.635.23h.5v-2.028l-.527.029c-.27.014-.578-.052-.933-.128l-.158-.033a3.21 3.21 0 0 1-.686-.384c-.283-.241-.512-.588-.696-1V13.5h1v-2h-1V7.02c.19-.438.42-.833.71-1.084.204-.147.453-.28.718-.38.29-.049.696-.079 1.04-.057l.532.033V3.5H15c-.505 0-1.032.013-1.567.12l-.034.007-.032.01c-.538.187-.98.422-1.382.719l-.013.01-.012.01c-.178.15-.332.307-.47.469-.147-.16-.3-.307-.445-.44l-.016-.016-.018-.013a4.41 4.41 0 0 0-1.397-.73l-.023-.008-.024-.005C8.98 3.513 8.51 3.5 8 3.5h-.5v2.033l.532-.034c.348-.022.705.007 1.062.077.204.068.438.188.65.346.29.274.573.682.756 1.097V11.5h-1v2h1v3.457a3.392 3.392 0 0 1-.79 1.07c-.177.13-.41.25-.662.33l-.232.048c-.289.061-.532.112-.784.096l-.532-.035V20.5H8c.528 0 .985-.092 1.436-.183l.08-.016.023-.005.023-.007a4.388 4.388 0 0 0 1.413-.713l.018-.014.016-.015Z"
                    fill="#000" stroke="#fff" />
            </svg>
        )
    ],
    [
        SvgIcons.cursor_vertical_text,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M19.547 12.99a7.522 7.522 0 0 0-.48-.482c.157-.136.309-.285.451-.456l.01-.01.008-.012c.313-.422.549-.863.716-1.332l.011-.031.007-.032c.117-.54.23-1.074.23-1.635v-.5h-2.028l.029.527c.014.27-.052.578-.128.933l-.033.158a3.21 3.21 0 0 1-.384.686c-.241.283-.588.512-1 .696H13.5v-1h-2v1H7.02c-.438-.19-.833-.42-1.084-.71a3.101 3.101 0 0 1-.38-.718 4.936 4.936 0 0 1-.057-1.04l.033-.532H3.5V9c0 .505.013 1.032.12 1.567l.007.034.01.032c.187.538.422.98.719 1.382l.01.013.01.012c.15.178.307.332.469.47-.16.147-.307.3-.44.445l-.016.016-.013.018a4.41 4.41 0 0 0-.73 1.397l-.008.023-.005.024C3.513 15.02 3.5 15.49 3.5 16v.5h2.033l-.034-.532a4.172 4.172 0 0 1 .077-1.062c.068-.204.188-.438.346-.65.274-.29.682-.573 1.097-.756H11.5v1h2v-1h3.457c.393.176.759.455 1.07.79.13.177.25.41.33.662l.048.232c.061.289.112.532.096.784l-.035.532H20.5V16c0-.528-.092-.985-.183-1.436l-.016-.08-.005-.023-.007-.023a4.388 4.388 0 0 0-.713-1.413l-.014-.018-.015-.016Z"
                    fill="#000" stroke="#fff" />
            </svg>
        )
    ],
    [
        SvgIcons.cursor_alias,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M17 3H7.2l3.29 3.2-.57.63a14.46 14.46 0 0 0-1 1.52 10 10 0 0 0-.67 2 13.38 13.38 0 0 0 0 2.13 7.31 7.31 0 0 0 .3 1.64 6 6 0 0 0 .63 1.38 6 6 0 0 0 1 1.19c.685.468 1.408.88 2.16 1.23a9.52 9.52 0 0 1-.94-1.75 12.274 12.274 0 0 1-.28-1.53c-.05-.528-.07-1.06-.06-1.59a5 5 0 0 1 .19-1.13c.163-.47.4-.913.7-1.31.238-.328.506-.632.8-.91.268-.26.552-.505.85-.73L17 12.2V3Z"
                        fill="#fff" />
                    <path
                        d="M16 10V4h-6l1.85 1.78c-.14.15-.33.34-.44.48-.28.35-.44.54-.61.73-.17.19-.26.32-.38.47a5.477 5.477 0 0 0-.36.57c-.11.2-.23.46-.37.75a4.35 4.35 0 0 0-.32 1 7.39 7.39 0 0 0-.17 1 7.12 7.12 0 0 0 0 .76 7 7 0 0 0 0 1c.089.59.25 1.169.48 1.72l.46.93c-.09-.757-.13-1.518-.12-2.28a5.732 5.732 0 0 1 .49-1.73 2.07 2.07 0 0 1 .19-.42l.36-.57c.21-.34.65-.87.76-1 .291-.329.605-.636.94-.92l.79-.67L16 10Z"
                        fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_copy,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)" fillRule="evenodd" clipRule="evenodd">
                    <path d="M3 11a9 9 0 1 0 18.001-.001A9 9 0 0 0 3 11Z" fill="url(#cursor_copy-b)" />
                    <path d="M13 10V7a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2h-3Z"
                          fill="#fff" />
                </g>
                <defs>
                    <linearGradient
                        id="cursor_copy-b" x1="12.4" y1="9.6" x2="12.4" y2="20.4"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#5CD331" />
                        <stop offset="1" stopColor="#078C04" />
                    </linearGradient>
                </defs>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_move,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                {/*<g filter="url(#filter0_1)">*/}
                <path d="m12 4-8 8 5.22 5.22L12 20l8-8-8-8Zm-2 11H9v-1h1v1Zm0-5H9V9h1v1Zm5 5h-1v-1h1v1Zm-1-6h1v1h-1V9Z"
                      fill="#fff" />
                <path d="m19 12-3-3v2H8V9l-3 3 3 3v-2h8v2l3-3Z" fill="#000" />
                <path d="M12 5 9 8h2v8H9l3 3 3-3h-2V8h2l-3-3Z" fill="#000" />
                {/*</g>*/}
            </svg>
        )
    ],
    [
        SvgIcons.cursor_all_scroll,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                {/*<g filter="url(#filter0_1)">*/}
                <path d="m12 4-8 8 5.22 5.22L12 20l8-8-8-8Zm-2 11H9v-1h1v1Zm0-5H9V9h1v1Zm5 5h-1v-1h1v1Zm-1-6h1v1h-1V9Z"
                      fill="#fff" />
                <path d="m19 12-3-3v2H8V9l-3 3 3 3v-2h8v2l3-3Z" fill="#000" />
                <path d="M12 5 9 8h2v8H9l3 3 3-3h-2V8h2l-3-3Z" fill="#000" />
                {/*</g>*/}
            </svg>
        )
    ],
    [
        SvgIcons.cursor_no_drop,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M12 1.5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 12 1.5Zm-3.39 4a6.42 6.42 0 0 1 3.39-1 6.51 6.51 0 0 1 6.5 6.5 6.42 6.42 0 0 1-1 3.39L8.61 5.5Zm3.39 12A6.51 6.51 0 0 1 5.5 11a6.42 6.42 0 0 1 1-3.42l8.94 8.94a6.42 6.42 0 0 1-3.42 1L12 17.5Z"
                        fill="#fff" />
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M3 11a9 9 0 1 0 18.001-.001A9 9 0 0 0 3 11Zm4.826-5.61A6.963 6.963 0 0 1 12 4a7 7 0 0 1 7 7c0 1.567-.52 3.008-1.39 4.174L7.826 5.39ZM5 11c0-1.578.529-3.029 1.409-4.199l9.79 9.79A6.96 6.96 0 0 1 12 18a7 7 0 0 1-7-7Z"
                          fill="url(#cursor_no_drop-b)" />

                </g>
                <defs>
                    <linearGradient
                        id="cursor_no_drop-b" x1="12.4" y1="9.6" x2="12.4" y2="20.4"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#F1F1F1" />
                        <stop offset="1" stopColor="#D6D6D6" />
                    </linearGradient>
                </defs>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_not_allowed,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M12 1.5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 12 1.5Zm-3.39 4a6.42 6.42 0 0 1 3.39-1 6.51 6.51 0 0 1 6.5 6.5 6.42 6.42 0 0 1-1 3.39L8.61 5.5Zm3.39 12A6.51 6.51 0 0 1 5.5 11a6.42 6.42 0 0 1 1-3.42l8.94 8.94a6.42 6.42 0 0 1-3.42 1L12 17.5Z"
                        fill="#fff" />
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M3 11a9 9 0 1 0 18.001-.001A9 9 0 0 0 3 11Zm4.826-5.61A6.963 6.963 0 0 1 12 4a7 7 0 0 1 7 7c0 1.567-.52 3.008-1.39 4.174L7.826 5.39ZM5 11c0-1.578.529-3.029 1.409-4.199l9.79 9.79A6.96 6.96 0 0 1 12 18a7 7 0 0 1-7-7Z"
                          fill="url(#cursor_not_allowed-b)" />
                </g>
                <defs>
                    <linearGradient
                        id="cursor_not_allowed-b" x1="12.4" y1="9.6" x2="12.4" y2="20.4"
                        gradientUnits="userSpaceOnUse">
                        <stop stopColor="#F1F1F1" />
                        <stop offset="1" stopColor="#D6D6D6" />
                    </linearGradient>
                </defs>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_zoom_in,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path d="m14.889 12.48 5.116 5.115-1.415 1.414-5.116-5.116a6 6 0 1 1 1.415-1.413Z" fill="#000" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M10 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" fill="#fff" />
                    <path d="M13 8h-2V6H9v2H7v1.98h2V12h2V9.98h2V8Z" fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_zoom_out,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path d="m14.889 12.48 5.116 5.115-1.415 1.414-5.116-5.116a6 6 0 1 1 1.415-1.413Z" fill="#000" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M10 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" fill="#fff" />
                    <path d="M13 8.02H7.02V10H13V8.02Z" fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_grab,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M8.38 12.27c-.1-.37-.2-.85-.41-1.55-.21-.7-.34-.86-.47-1.23-.13-.37-.3-.72-.5-1.18-.183-.47-.337-.95-.46-1.44a1.43 1.43 0 0 1 .28-1.17 1.41 1.41 0 0 1 1.36-.35c.379.166.7.44.92.79.295.472.537.975.72 1.5.282.72.486 1.467.61 2.23l.09.45V9.16c0-1-.06-1.82 0-2.94 0-.13.06-.59.08-.72a1.19 1.19 0 0 1 .67-1c.445-.2.955-.2 1.4 0 .399.178.665.564.69 1 0 .11.09 1 .09 1.11V10.25a29 29 0 0 1 .34-3.94 1.49 1.49 0 0 1 .79-.93 1.37 1.37 0 0 1 1.4.24c.288.316.458.723.48 1.15V10.32c.09-.28.19-.54.27-.74.08-.2.24-.61.36-.86.122-.238.26-.469.41-.69a1.38 1.38 0 0 1 .67-.56 1 1 0 0 1 1.3.59c.06.364.06.736 0 1.1a9.342 9.342 0 0 1-.35 1.65c-.13.45-.27 1.23-.34 1.6-.07.37-.23 1.38-.36 1.82a5.913 5.913 0 0 1-.79 1.47 7.24 7.24 0 0 0-1.19 1.81 4.052 4.052 0 0 0-.1 1c-.002.31.039.62.12.92a5.8 5.8 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.23.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92c-.28-.36-.63-1.09-1.24-2-.35-.5-1-1.09-1.28-1.58a1.75 1.75 0 0 1-.19-1.32 1.21 1.21 0 0 1 1.37-.86 2 2 0 0 1 1.24.54c.268.232.518.482.75.75.16.19.2.28.38.51.18.23.3.46.21.12"
                        fill="#fff" />
                    <path
                        d="M8.38 12.27c-.1-.37-.2-.85-.41-1.55-.21-.7-.34-.86-.47-1.23-.13-.37-.3-.72-.5-1.18-.183-.47-.337-.95-.46-1.44a1.43 1.43 0 0 1 .28-1.17 1.41 1.41 0 0 1 1.36-.35c.379.166.7.44.92.79.295.472.537.975.72 1.5.282.72.486 1.467.61 2.23l.09.45V9.16c0-1-.06-1.82 0-2.94 0-.13.06-.59.08-.72a1.19 1.19 0 0 1 .67-1c.445-.2.955-.2 1.4 0 .399.178.665.564.69 1 0 .11.09 1 .09 1.11V10.25a29 29 0 0 1 .34-3.94 1.49 1.49 0 0 1 .79-.93 1.37 1.37 0 0 1 1.4.24c.288.316.458.723.48 1.15V10.32c.09-.28.19-.54.27-.74.08-.2.24-.61.36-.86.122-.238.26-.469.41-.69a1.38 1.38 0 0 1 .67-.56 1 1 0 0 1 1.3.59c.06.364.06.736 0 1.1a9.342 9.342 0 0 1-.35 1.65c-.13.45-.27 1.23-.34 1.6-.07.37-.23 1.38-.36 1.82a5.913 5.913 0 0 1-.79 1.47 7.24 7.24 0 0 0-1.19 1.81 4.052 4.052 0 0 0-.1 1c-.002.31.039.62.12.92a5.8 5.8 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.23.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92c-.28-.36-.63-1.09-1.24-2-.35-.5-1-1.09-1.28-1.58a1.75 1.75 0 0 1-.19-1.32 1.21 1.21 0 0 1 1.37-.86 2 2 0 0 1 1.24.54c.268.232.518.482.75.75.16.19.2.28.38.51.18.23.3.46.21.12"
                        fill="#fff" stroke="#000"
                        strokeWidth=".75" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M15.75 16.43v-3.45a.375.375 0 0 0-.75 0v3.45a.375.375 0 0 0 .75 0ZM13.76 16.43l-.01-3.453a.374.374 0 0 0-.75.002l.01 3.454a.374.374 0 0 0 .75-.002ZM11.005 12.98l.02 3.444c.001.21.17.377.377.376a.376.376 0 0 0 .373-.38l-.02-3.445a.376.376 0 0 0-.377-.375.376.376 0 0 0-.373.38Z"
                        fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_grabbing,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <g filter="url(#filter0_1)">
                    <path
                        d="M8 7.15c.48-.18 1.43-.07 1.68.47s.4 1.24.41 1.07a6.39 6.39 0 0 1 .13-1.54 1.11 1.11 0 0 1 .69-.69 1.93 1.93 0 0 1 .92-.06c.31.064.585.242.77.5.234.583.366 1.202.39 1.83a6.543 6.543 0 0 1 .27-1.58 1.24 1.24 0 0 1 .69-.48c.33-.06.67-.06 1 0a1.4 1.4 0 0 1 .68.49c.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 1 1 1.9.64v2.26a11.633 11.633 0 0 1-.24 1.74 5.872 5.872 0 0 1-.72 1.43 7.223 7.223 0 0 0-1.19 1.81 4.12 4.12 0 0 0-.1 1c-.001.31.04.62.12.92a5.786 5.786 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1 1.11-.67.08-2.06 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92a4.45 4.45 0 0 1-1.24-2c-.21-.94-.19-1.39 0-1.77a1.5 1.5 0 0 1 .85-.65 1.8 1.8 0 0 1 .88.06c.196.082.366.217.49.39.23.31.31.46.21.12s-.32-.59-.43-1a4.58 4.58 0 0 1-.38-1.53 1.14 1.14 0 0 1 .83-1"
                        fill="#fff" />
                    <path
                        d="M8 7.15c.48-.18 1.43-.07 1.68.47s.4 1.24.41 1.07a6.39 6.39 0 0 1 .13-1.54 1.11 1.11 0 0 1 .69-.69 1.93 1.93 0 0 1 .92-.06c.31.064.585.242.77.5.234.583.366 1.202.39 1.83a6.543 6.543 0 0 1 .27-1.58 1.24 1.24 0 0 1 .69-.48c.33-.06.67-.06 1 0a1.4 1.4 0 0 1 .68.49c.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 1 1 1.9.64v2.26a11.633 11.633 0 0 1-.24 1.74 5.872 5.872 0 0 1-.72 1.43 7.223 7.223 0 0 0-1.19 1.81 4.12 4.12 0 0 0-.1 1c-.001.31.04.62.12.92a5.786 5.786 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1 1.11-.67.08-2.06 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92a4.45 4.45 0 0 1-1.24-2c-.21-.94-.19-1.39 0-1.77a1.5 1.5 0 0 1 .85-.65 1.8 1.8 0 0 1 .88.06c.196.082.366.217.49.39.23.31.31.46.21.12s-.32-.59-.43-1a4.58 4.58 0 0 1-.38-1.53c.02-.48.34-.897.8-1.04Z"
                        fill="#fff" stroke="#000"
                        clipRule="evenodd"
                        strokeWidth=".75" strokeLinejoin="round" />
                    <path
                        d="M15.75 14.826v-3.452a.375.375 0 0 0-.75 0v3.452a.375.375 0 0 0 .75 0ZM13.77 14.825l-.02-3.454a.374.374 0 0 0-.75.004l.02 3.454a.374.374 0 0 0 .75-.004ZM11 11.38l.02 3.444c.001.21.17.377.377.376a.376.376 0 0 0 .373-.38l-.02-3.444a.376.376 0 0 0-.377-.376.376.376 0 0 0-.373.38Z"
                        fill="#000" />
                </g>
            </svg>
        )
    ],
    [
        SvgIcons.cursor_custom,
        props => null
    ],
]);
